import { PathSegmentResolver } from '../../utils/use-path';

export const resolveFilterSearchPath: PathSegmentResolver = ({ defaultLink }) => {
  return {
    title: 'Sök enligt miljöbedömning',
    isPageTitle: true,
    link: defaultLink + location.search, // add search path to keep filters
  };
};
